import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-[var(--color-primary)] text-slate-200 text-center p-3 text-xs mt-auto no-print">
      <p>&copy; {new Date().getFullYear()} Tech Medics Inc. All rights reserved.</p>
      <p>Command Center v1.0.0</p>
    </footer>
  );
};